import React, { type ComponentProps } from 'react';
import { ProductCard as GarnishProductCard } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const ProductCard = (props: ProductCardProps) => {
  const shouldUseLargeImageSize = useFeatureFlag(
    'MNU-3431-short-s5-image-size-updates',
  );

  const imageSize = shouldUseLargeImageSize ? 'large' : 'regular';

  return <GarnishProductCard imageSize={imageSize} {...props} />;
};

type ProductCardProps = ComponentProps<typeof GarnishProductCard>;
